<template>
  <div id='mutations-table-body'>
    
      <el-row :gutter="10" style="background-color: rgba(0, 0, 0, 0.1); padding: 15px; border-radius: 10px">
        <el-col :span="24" style="padding: 10px; text-align: left">
          <span class="fas icon-fa-filter" :style="`margin-right: 10px; color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`"></span>
          <span :style="`font-size: 1.2em; font-weight: bold; color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`">Filters</span>
        </el-col>
        <el-col :span="12">
          <div :style="`text-align: left; margin-left: 20px; margin-bottom: 5px; color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`">Genes</div>
          <el-select v-model="store.mutationComponent.tableFilters.genes" multiple
            style="margin-left: 20px; width: 100%" placeholder="Select" @change="applyFilters">
            <el-option v-for="item in store.mutationComponent.tableSettings.genes" :key="item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      
      <el-row :gutter="10">
        <el-col style="margin-top: 20px;" :xs="{span: 24, offset: 0}" 
          :sm="{span: 17, offset: 1}" :md="{span: 17, offset: 1}" 
          :lg="{span: 17, offset: 1}" :xl="{span: 17, offset: 1}" align="left">
          <el-pagination small @size-change="store.mutationComponent.methods.handlePageChange"
            @current-change="store.mutationComponent.methods.handlePageChange"
            :current-page.sync="store.mutationComponent.tableSettings.query.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size.sync="store.mutationComponent.tableSettings.query.pageSize"
            :layout="paginationLayout"
            :pager-count="5"
            :total="store.mutationComponent.tableSettings.totalEntries"
            :style="`color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`">
          </el-pagination>
        </el-col>

        <el-col style="margin-top: 20px;" :xs="{span: 24, offset: 0}" 
          :sm="{span: 5}" :md="{span: 5}" 
          :lg="{span: 5}" :xl="{span: 5}" align="right">
          <!-- <el-tooltip content="Table filters" placement="top">
            <el-button type="danger" size="small" style="margin-right: 10px" @click="openFilterModal">
              <i class="fas icon-fa-filter" style="font-size: 1.2em"></i>
            </el-button>
          </el-tooltip>

          <el-tooltip content="Reset filters" placement="top">
            <el-button type="success" size="small" style="margin-right: 10px; margin-left: 0px" @click="resetFilters">
              <i class="fas icon-fa-sync" style="font-size: 1.2em"></i>
            </el-button>
          </el-tooltip> -->

          <el-tooltip content="Download TSV" placement="top">
            <el-button type="primary" size="small" style="margin-left: 0px" @click="downloadVariantTableTSV">
              <i class="fas icon-fa-download" style="font-size: 1.2em"></i>
            </el-button>
          </el-tooltip>
        </el-col>
      </el-row>
            
      <el-row :style="`text-align: left; padding-top: 10px; color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`">
        <i class="fas icon-fa-info-circle"></i>
        Click on each row for more details about the mutation.
      </el-row>

      <el-row v-loading="store.mutationComponent.tableSettings.tableData.length === 0"
        style="margin-top: 5px; font-family: 'Oxygen', Arial; backgroundColor: rgba(0,0,0,0)">
        <el-table :height="'60vh'" id="mutations-table" 
          :data="store.mutationComponent.tableSettings.tableData" 
          @row-click="mutationExplore" :row-style="{cursor: 'pointer'}" border
          :header-cell-style="headerCellStyle" size="medium" style="border-radius: 5px">

          <el-table-column label="S.no" prop="index" width="70">
          </el-table-column>

          <el-table-column label="Gene" prop="gene" width="160">
            <template slot="header" slot-scope="prop">
              <div style="cursor: pointer" @click="sortTable(prop.$index, prop.column)">
                Gene
                <i style="margin-left: 10px" :class="store.settings.sortIcons[store.mutationComponent.tableSettings.columns[prop.$index].sort]"></i>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="Position" prop="position" width="120">
            <template slot="header" slot-scope="prop">
              <div style="cursor: pointer" @click="sortTable(prop.$index, prop.column)">
                Position
                <i style="margin-left: 10px" :class="store.settings.sortIcons[store.mutationComponent.tableSettings.columns[prop.$index].sort]"></i>
              </div>
            </template>
            <template slot-scope="prop">
              {{ prop.row.position }} 
              <!-- {{ prop.row.ref }}
              <span style="font-family: 'Manrope', Helvetica, Arial, sans-serif"> -> </span>
              {{ prop.row.alt }} -->
            </template>
          </el-table-column>

          <el-table-column label="Ref AA" prop="ref" width="80">
            <template slot="header">
              <div style="cursor: pointer">
                Ref AA
              </div>
            </template>
            <template slot-scope="prop">
              {{ prop.row.ref }}
            </template>
          </el-table-column>

          <el-table-column label="Alt AA" prop="alt" width="80">
            <template slot="header">
              <div style="cursor: pointer">
                Alt AA
              </div>
            </template>
            <template slot-scope="prop">
              {{ prop.row.alt }}
            </template>
          </el-table-column>

          <el-table-column label="Percentage" prop="percent">
            <template slot="header" slot-scope="prop">
              <div style="cursor: pointer" @click="sortTable(prop.$index, prop.column)">
                Percentage
                <i style="margin-left: 10px" :class="store.settings.sortIcons[store.mutationComponent.tableSettings.columns[prop.$index].sort]"></i>
              </div>
            </template>

            <template slot-scope="props">
              <el-tooltip class="item" effect="dark" :content="`${props.row.count} Genomes`" placement="top-start">
                <el-progress :stroke-width="15"  id="mutations-table-percentage" :percentage="parseFloat(props.row.percent)"></el-progress>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-row>

      <el-dialog :visible.sync="filterVisible" id="mutations-table-filters">
        <el-row slot="title" style="padding: 15px 20px 15px 20px; background-color: #4e4e4e; color: #dedede">
          <el-col style="font-family: 'HammerSmith One', sans-serif; font-size: 1.2em; padding: 0px">
            Variant Filters
          </el-col>
        </el-row>

        <!-- <el-row>
          <el-row :gutter="20">
            <el-col style="margin-top: 20px; font-weight: bold; font-size: 1.2em" :span="24" align="left">
              Position
            </el-col>

            <el-col style="margin-top: 10px" :span="22" :offset="1" align="left">
              <div style="font-weight: bold; text-align: left">
                <el-checkbox v-model="store.mutationComponent.tableFilters.positionFilterType.genomic"
                  @change="positionFilterCheck('genomic')" style="margin-right: 10px" ></el-checkbox>
                Genomic
              </div>
              <el-input-number style="width: 120px; margin-top: 5px" size="small" controls-position="right" 
                @change="positionFilterControl('genomic')"
                v-model="store.mutationComponent.tableFilters.startPosition" ></el-input-number>
              <span style="font-weight: bold; font-size: 1.2em; margin-left: 10px; margin-right: 10px">-</span>
              <el-input-number style="width: 120px; margin-top: 5px" size="small" controls-position="right" 
                @change="positionFilterControl('genomic')"
                v-model="store.mutationComponent.tableFilters.endPosition" ></el-input-number>
            </el-col>

            <el-col style="margin-top: 20px" :span="22" :offset="1" align="left">
              <div style="font-weight: bold; margin-right: 5px">
                <el-checkbox v-model="store.mutationComponent.tableFilters.positionFilterType.feature" 
                  @change="positionFilterCheck('feature')" style="margin-right: 10px" ></el-checkbox>
                Gene
              </div>
              <el-select v-model="store.mutationComponent.tableFilters.features" size="small" @change="positionFilterControl('feature')" multiple>
                <el-option v-for="f in store.mutationComponent.tableSettings.features" :key="f" :label="f" :value="f"></el-option>
              </el-select>
            </el-col>

            <el-col style="margin-top: 20px" :span="22" :offset="1" align="left">
              <div style="font-weight: bold; text-align: left">
                <el-checkbox v-model="store.mutationComponent.tableFilters.positionFilterType.aa"
                  @change="positionFilterCheck('aa')" style="margin-right: 10px" ></el-checkbox>
                Amino Acid position
              </div>
              <el-input size="mini" style="max-width: 200px" placeholder="Protein:AA position" 
                v-model="store.mutationComponent.tableFilters.aaPosition" @focus="positionFilterControl('aa')"></el-input>
              
              <div style="font-size: 0.9em; font-weight: bold; font-style: italic">Example: S:614</div>
            </el-col>

            <el-col style="margin-top: 20px; font-weight: bold; font-size: 1.2em" :span="24" align="left">
              Percentage prevalance
            </el-col>
            <el-col style="margin-top: 10px" :span="22" :offset="1" align="left">
              <el-slider range :min="0" :max="100" v-model="store.mutationComponent.tableFilters.percentSliderRange" style="width: 80%; margin-left: 10px"></el-slider>
            </el-col>


            <el-col style="margin-top: 20px" :span="22" :offset="1" align="right">
              <el-button type="primary" @click="applyFilters()">Apply</el-button>
            </el-col>
          </el-row>
        </el-row> -->
      </el-dialog>
  </div>
</template>

<script>
  import IEcharts from 'vue-echarts-v3/src/full.js'

  // import { downloadTSV } from '@/scripts/utils.js'
  import { store } from '@/scripts/store.js'

  const _ = require('lodash')
  const echarts = require('echarts')
  
  export default {
    name: 'MutationsTable',
    props: { },
    components: { 
      IEcharts 
    },
    data() {
      const columns = store.mutationComponent.tableSettings.columns
      return { 
        store: store,
        columns: columns.slice(4, columns.length),
        variantSelected: {},
        filterVisible: false,
        paginationLayout: 'total, sizes, prev, pager, next, jumper',
      };
    },
    mounted() { 
      const context = this
      console.log('initialising the table')
      context.initialiseTable()
    },
    computed: {
      headerCellStyle() {
        const borderColor = store.theme.viewMode.tableBorder[store.theme.viewMode.active]
        return { backgroundColor: '#aa6389', borderRight: `1px solid ${borderColor}`, color: '#eeeeee', borderBottom: 'none'}
      } 
      
    },
    created() {
      window.addEventListener('resize', this.handleResize);
      // this.handleResize();
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize)
    },
    methods: {
      initialiseTable() {
        store.mutationComponent.methods.initialiseTable()
      },
      sortTable: function(val, column) {
        const nonSort = ['index', 'ref', 'alt']
        if (nonSort.indexOf(column.property) === -1) {
          store.mutationComponent.methods.sortTable(column.property)
        }
      },
      openFilterModal() {
        this.filterVisible = true
      },
      applyFilters () {
        // this.filterVisible = false
        store.mutationComponent.methods.applyFilters()
      },
      positionFilterControl(type) {
        store.mutationComponent.methods.positionFilterControl(type)
      },
      positionFilterCheck (type) {
        store.mutationComponent.methods.positionFilterCheck(type)
      },
      resetFilters () {
        store.mutationComponent.methods.initialiseTable()
      },

      updateTable() {
        const instance = echarts.getInstanceByDom(document.getElementById('mutation-chart'))
        // store.mutationComponent.methods.updateTable()
      },
      mutationExplore(val, col, event) {
        console.log(val)
        const element = document.getElementById('mutation-data')
        var top = element.offsetTop;
        window.scrollTo(0, top);

        store.mutationComponent.methods.selectRow('Called selectRow from MutationTable.vue', val)
      },
      handleResize: function() {
        const context = this
        if (screen.width < 600) { context.paginationLayout = 'total, sizes, jumper' } 
        else if ( screen.width < 900 ) { context.paginationLayout = 'total, sizes, jumper, prev, next' }
        else { context.paginationLayout = 'total, sizes, prev, pager, next, jumper' }
      },
      downloadVariantTableTSV: function() {
        const context = this
        store.mutationComponent.methods.downloadTable()
      },
      cladesBarOptions: function(data) {
        const clades = _.map(data, 'clade')
        const counts = _.map(data, 'count')
        clades.reverse()
        const total = _.sum(counts)
        const series = _.map(data, d => {
          const percent = parseFloat(((d.count/total)*100).toFixed(2))
          return { 
            type: 'bar',  name: d.clade, stack: 'Clades', itemStyle: { color: store.theme.colors.nextstrain_clades[d.clade]},
            data: [percent]
          }
        })
        return {
          grid: { height: 20, width: 120, left: 0, right: 0, top: 15, bottom: 15 },
          tooltip: {
            textStyle: { fontFamily: store.theme.fontFamily.plotTooltip }, borderColor: '#bebebe', borderWidth: 1,
            show: true, appendToBody: true, trigger: 'axis', axisPointer: { type: 'shadow' },
            backgroundColor: 'rgba(250,250,250,1)', padding: 10, 
            formatter: function(val) {
              const string = _.map(val, v => {
                const clade = v.seriesName
                const count = _.filter(data, d => { return d.clade === clade })[0].count
                return `<span style="color: ${store.theme.colors.nextstrain_clades[clade]}"><i class="fas icon-fa-circle" style="margin-right: 5px; font-size: 0.8em"></i>${v.seriesName}: ${v.data}% (${count})</span><br>`
              })
              return `
                <span style="color: #4e4e4e">\
                Clade distribution:<br>\
                ${string.join('\n')}\
                </span>
              `
            } 
          },
          series: series,
          xAxis: { show: false, min: 0, max: 100 },
          yAxis: {show: false, data:['Clades']}
        }
      }
    }
  }
</script>

<style> 
  
  .variant-arrow {
    font-family: Manrope, Helvetica, Arial, sans-serif;
  }

  #mutations-table-percentage .el-progress-bar {
    width: 80% !important;
  }
  
  .mutation-card .el-card__header {
    font-weight: bold;
    background:  linear-gradient(90deg, #f05c39, #f47725);
    color: #eeeeee;
  }

  .demonstration {
    color: #4e4e4e;
  }

  .el-pagination {
    padding: 0px !important;
  }

  span.el-pagination__jump {
    margin-left: 4px;
  }

  .table-filters div.el-collapse-item__header {
    background: linear-gradient(90deg, #665191, #875296) !important;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    -webkit-transition-property: border-radius;
    -webkit-transition-duration: 1s;
    -webkit-transition-timing-function: ease;
    transition-property: border-radius;
    transition-duration: 1s;
    transition-timing-function: ease;
  }

  .table-filters div.el-collapse-item__header.is-active {
    background: linear-gradient(90deg, #665191, #875296) !important;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    -webkit-transition-property: border-radius;
    -webkit-transition-duration: 0s;
    -webkit-transition-timing-function: ease;
    transition-property: border-radius;
    transition-duration: 0s;
    transition-timing-function: ease;
  }

  .table-filters div.el-collapse-item__content {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border: 1px #bebebe solid !important;
  }

  .table-filters i.el-icon-arrow-right {
    color: white !important;
  }

  #mutations-table {
    background-color: rgba(0,0,0,0);
    border: none;
  }

  #mutations-table .el-table__header-wrapper .el-table__header thead tr {
    background-color: rgba(0,0,0,0);
  }

  #mutations-table .el-table__body-wrapper .el-table__body tbody tr {
    background-color: rgba(255,255,255,0.7);
  }

  #mutations-table .el-table__body-wrapper .el-table__body tbody tr td {
    padding: 3px;
  }

  #mutations-table-body .el-col .el-pagination .el-pagination__total {
    vertical-align: center;
    background-color: rgba(255,255,255,0.8);
    box-sizing: unset;
    border-radius: 5px;
    padding: 3px 10px;
    color: #AA6389;
    font-weight: bold;
  }

  #mutations-table-body .el-col .el-pagination .el-pager li.number.active {
    color: #AA6389;
  }

  #mutations-table-body .el-col .el-pagination .btn-next {
    background-color: rgba(255,255,255,0.8);
    border-radius: 5px;
    margin-left: 5px;
    padding: 3px;
  }

  #mutations-table-body .el-col .el-pagination .el-pager .btn-quicknext {
    background-color: rgba(255,255,255,0.8);
    border-radius: 5px;
    padding: 0px 3px 0px 3px;
  }

  #mutations-table-body .el-col .el-pagination .el-pager .btn-quicknext:hover {
    color: #AA6389;
  }

  #mutations-table-body .el-col .el-pagination .btn-next:hover {
    color: #AA6389;
  }

  #mutations-table-body .el-col .el-pagination .btn-prev {
    background-color: rgba(255,255,255,0.8);
    border-radius: 5px;
    padding: 3px;
  }

  #mutations-table-body .el-col .el-pagination .el-pager .btn-quickprev {
    background-color: rgba(255,255,255,0.8);
    border-radius: 5px;
    padding: 0px 3px 0px 3px;
  }

  #mutations-table-body .el-col .el-pagination .el-pager .btn-quickprev:hover {
    color:#AA6389;
  }

  #mutations-table-body .el-col .el-pagination .btn-prev:hover {
    color: #AA6389;
  }

  #mutations-table-body .el-col .el-pagination .el-pager * {
    background-color: rgba(0,0,0,0);
  }

  #mutations-table-filters .el-dialog .el-dialog__header {
    padding: 0px;
  }

  #mutations-table-filters .el-dialog {
    max-width: 500px;
  }

  #mutations-table-percentage .el-progress-bar .el-progress-bar__outer {
    background-color: #dbdbdb;
  }



</style>